$(function() {
  $('.js-table').each(function() {
    var $ctr = $(this)
    var $table= $ctr.find('.js-table-data')
    var $head = $table.find('thead')
    $ctr.find('.js-table-header').append($head[0]);
    $table.parent().width($head.width())
  });
});
